/**
 * Used to interact with the parent window when the designer
 * is loaded in an iframe, etc. Javascript on the parent side
 * can intercept these messages and interpret as needed.
 * @type {Object}
 */
export const windowMessaging = {
    data () {
        return {
        }
    },
    methods: {
        /**
         * Default function used to post to iframe window
         * @param  {Object}
         */
        postMsg (data) {
            parent.window.postMessage(data, '*')
        },
        /**
         * Called to post to parent window when the page is resized
         * @param  {Number}
         * @param  {Number}
         */
        windowMsgTemplateResize (height, width) {
            this.postMsg({'type': 'templateResize', 'height': height, 'width': width})
        },
        windowMsgLoaded () {
            this.postMsg({'type': 'loaded'})
        },
        /**
         * Called to post to the parent window when the template has been updated (saved)
         * @param  {Object}
         */
        windowMsgTemplateUpdate (data) {
            this.postMsg({'type': 'templateUpdate', 'data': data})
        },
        /**
         * Called to post to the parent window when the template status has changed (saved / unsaved)
         * @param  {Object}
         */
        windowMsgTemplateStatus (data) {
            this.postMsg({'type': 'templateStatus', 'data': data})
        },
        windowMsgScrollToIframe () {
            this.postMsg({'type': 'scrollToiFrame', 'data': {'scroll': true}})
        },
        windowMsgLockWindow ($status = true) {
            this.postMsg({'type': 'windowLock', 'data': {'status': $status}})
        },

        windowMsgDownloadFiles (url) {
            this.postMsg({'type': 'downloadFiles', 'data': {'url': url}})
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/mixins/windowMessaging.js